(ns frontend.view.settings2.security.ai-admin.sub
  "Subscriptions for the AI services admin panel."
  (:require
   [frontend.view.settings2.security.ai-admin.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub ::loading? :<- [::state] (fn [s] (:loading? s true)))
(rf/reg-sub ::error :<- [::state] (fn [s] (get s :error)))
(rf/reg-sub ::saving? :<- [::state] (fn [s] (:saving? s false)))
(rf/reg-sub ::services :<- [::state] (fn [s] (:services s [])))
(rf/reg-sub ::task-config-drafts :<- [::state] (fn [s] (:task-config-drafts s {})))
(rf/reg-sub ::task-config-override-drafts :<- [::state]
            (fn [s] (:task-config-override-drafts s {})))
(rf/reg-sub ::deal-pipelines :<- [::state] (fn [s] (:deal-pipelines s [])))
(rf/reg-sub ::template-uploading :<- [::state] (fn [s] (:template-uploading s {})))
(rf/reg-sub
 ::template-uploading?
 :<- [::template-uploading]
 (fn [uploads]
   (boolean (some true? (vals uploads)))))
(rf/reg-sub ::default-service-id :<- [::state] (fn [s] (get s :default-service-id)))
(rf/reg-sub ::providers :<- [::state] (fn [s] (:providers s [])))
(rf/reg-sub ::task-types :<- [::state] (fn [s] (:task-types s [])))
(rf/reg-sub ::editing :<- [::state] (fn [s] (get s :editing)))
(rf/reg-sub ::testing? :<- [::state] (fn [s] (:testing? s false)))
(rf/reg-sub ::test-result :<- [::state] (fn [s] (get s :test-result)))
(rf/reg-sub ::verifications :<- [::state] (fn [s] (:verifications s {})))

(rf/reg-sub
 ::verification
 :<- [::verifications]
 (fn [verifications [_ service-id]]
   (get verifications service-id)))

(rf/reg-sub
 ::ai-status
 :<- [::services]
 :<- [::default-service-id]
 :<- [::verifications]
 (fn [[services default-service-id verifications] _]
   (model/ai-status {:services           services
                     :default-service-id default-service-id
                     :verifications      verifications})))

(rf/reg-sub
 ::task-config-draft
 :<- [::task-config-drafts]
 (fn [drafts [_ task-type]]
   (get drafts task-type {})))

(rf/reg-sub
 ::task-config-override-draft
 :<- [::task-config-override-drafts]
 (fn [drafts [_ task-type pipeline-id]]
   (get drafts [task-type pipeline-id] {})))
